export default {
  lineAt: '',
  linkLine: '',
  loaded: false
}

